import { render, staticRenderFns } from "./VacanciesEventsCards.vue?vue&type=template&id=600fb5c5&scoped=true&"
import script from "./VacanciesEventsCards.vue?vue&type=script&lang=js&"
export * from "./VacanciesEventsCards.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesEventsCards.vue?vue&type=style&index=0&id=600fb5c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600fb5c5",
  null
  
)

export default component.exports